import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { AssessmentTestDefinitionSchema } from './assessment-test';
export const GetCmsAssessmentTestParams = z.object({
    slug: z.string().min(1),
});
export const getCmsAssessmentTestsRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/assessment-tests',
    name: 'get-cms-assessment-tests',
    request: {},
    responses: { 200: z.array(AssessmentTestDefinitionSchema) },
};
export const getCmsAssessmentTestRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/assessment-tests/{slug}',
    name: 'get-cms-assessment-test',
    request: { params: GetCmsAssessmentTestParams },
    responses: {
        200: AssessmentTestDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
